module.exports = {
      id: "album-usage",
      viewBox: "0 0 25.602 21.762",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#album",
      toString: function () {
        return this.url;
      }
    }